export default __webpack_public_path__ + "64c8f3785ec278482579caab015fe7d4.png";